import React from "react";
import { LinearProgress, Box } from "@mui/material";

interface ScoreBarProps {
  progress: number;
  color: string;
}

const ScoreBar: React.FC<ScoreBarProps> = ({ progress, color }) => {
  return (
    <Box sx={{ width: "100%", color: color }}>
      <LinearProgress
        variant="determinate"
        value={progress}
        color="inherit"
        style={{
          height: 20,
          backgroundColor: "#F5F5F5",
        }}
      />
    </Box>
  );
};

export default ScoreBar;
